import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { ConfigFieldOption } from '@/eventConfig/types.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { useForm } from '@/form/useForm.ts';

export const AncestrySummaryFormCL = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['ancestry'] });

  const { getFieldValue } = useForm();
  const ancestryFather = getFieldValue('ancestryFather');
  const ethnicityFather = getFieldValue('ethnicityFather');
  const ancestryMother = getFieldValue('ancestryMother');
  const ethnicityMother = getFieldValue('ethnicityMother');

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  const ancestryFatherField = s.ancestry.fields.find(({ name }) => name === 'ancestryFather');
  const ancestryFatherLabel = translate(ancestryFatherField?.label);

  // Options are nested in groups, take them out
  const ancestryFatherOptions = (ancestryFatherField?.options || [])
    .reduce((acc, curr) => {
      return [...acc, curr, ...(curr?.options || [])];
    }, [] as ConfigFieldOption[])
    .filter(({ value }) => value !== '');

  const ancestryFatherValue =
    translate(ancestryFatherOptions.find(({ value }) => value === ancestryFather)?.label) || ancestryFather;

  const ethnicityFatherField = s.ancestry.fields.find(({ name }) => name === 'ethnicityFather');
  const ethnicityFatherLabel = translate(ethnicityFatherField?.label);

  // Options are nested in groups, take them out
  const ethnicityFatherOptions = (ethnicityFatherField?.options || [])
    .reduce((acc, curr) => {
      return [...acc, curr, ...(curr?.options || [])];
    }, [] as ConfigFieldOption[])
    .filter(({ value }) => value !== '');

  const ethnicityFatherValue =
    translate(ethnicityFatherOptions.find(({ value }) => `${value}` === ethnicityFather)?.label) || ethnicityFather;

  // Mother

  const ancestryMotherField = s.ancestry.fields.find(({ name }) => name === 'ancestryMother');
  const ancestryMotherLabel = translate(ancestryMotherField?.label);

  // Options are nested in groups, take them out
  const ancestryMotherOptions = (ancestryMotherField?.options || [])
    .reduce((acc, curr) => {
      return [...acc, curr, ...(curr?.options || [])];
    }, [] as ConfigFieldOption[])
    .filter(({ value }) => value !== '');

  const ancestryMotherValue =
    translate(ancestryMotherOptions.find(({ value }) => value === ancestryMother)?.label) || ancestryMother;

  const ethnicityMotherField = s.ancestry.fields.find(({ name }) => name === 'ethnicityMother');
  const ethnicityMotherLabel = translate(ethnicityMotherField?.label);

  // Options are nested in groups, take them out
  const ethnicityMotherOptions = (ethnicityMotherField?.options || [])
    .reduce((acc, curr) => {
      return [...acc, curr, ...(curr?.options || [])];
    }, [] as ConfigFieldOption[])
    .filter(({ value }) => value !== '');

  const ethnicityMotherValue =
    translate(ethnicityMotherOptions.find(({ value }) => `${value}` === ethnicityMother)?.label) || ethnicityMother;

  return (
    <div className="summary-card" data-cy={'summary-form-ancestry'}>
      <h2>{translate(s.dataSummary.titles?.ancestry)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{ancestryFatherLabel}</div>
        <div className={'value'}>
          {!editMode && ancestryFatherValue}
          {editMode && <EditDataField field={ancestryFatherField!} slideId={'ancestry'} />}
        </div>

        <div className={'label'}>{ethnicityFatherLabel}</div>
        <div className={'value'}>
          {!editMode && ethnicityFatherValue}
          {editMode && <EditDataField field={ethnicityFatherField!} slideId={'ancestry'} />}
        </div>

        <div className={'label'}>{ancestryMotherLabel}</div>
        <div className={'value'}>
          {!editMode && ancestryMotherValue}
          {editMode && <EditDataField field={ancestryMotherField!} slideId={'ancestry'} />}
        </div>

        <div className={'label'}>{ethnicityMotherLabel}</div>
        <div className={'value'}>
          {!editMode && ethnicityMotherValue}
          {editMode && <EditDataField field={ethnicityMotherField!} slideId={'ancestry'} />}
        </div>
      </div>
    </div>
  );
};
